import {
  IEventData,
  IFrpData,
  IFundraisingPagesData,
  IGDPRConsent,
  ILockData,
  IMembersListData,
  ITeamData,
  TMembershipPolicy,
} from '../../types/state.d';

import { IEditTeamFormProps } from '../../containers/EditTeam/EditTeam.d';
import { apiActionTypes } from './actionTypes';
import makeActionCreator from '../../utils/actionCreator';

export const saveUploadedCoverPhoto = makeActionCreator<[string]>(
  apiActionTypes.SAVE_UPLOADED_COVER_PHOTO,
  'heroImage',
);

export const isShortNameValid = makeActionCreator<[boolean]>(
  apiActionTypes.IS_SHORT_NAME_VALID,
  'isShortNameValid',
);

export const clearShortNameValidity = makeActionCreator(
  apiActionTypes.CLEAR_SHORT_NAME_VALIDITY,
);

export const teamRequestMade = makeActionCreator(
  apiActionTypes.TEAM_REQUEST_MADE,
);

export const teamRequestSuccess = makeActionCreator<[ITeamData]>(
  apiActionTypes.TEAM_REQUEST_SUCCESS,
  'teamData',
);

export const teamRequestError = makeActionCreator<[string]>(
  apiActionTypes.TEAM_REQUEST_ERROR,
  'errorStatus',
);

export const createEventRequestMade = makeActionCreator(
  apiActionTypes.CREATE_EVENT_REQUEST_MADE,
);

export const createEventRequestSuccess = makeActionCreator<[any]>(
  apiActionTypes.CREATE_EVENT_REQUEST_SUCCESS,
  'event',
);

export const createEventRequestError = makeActionCreator(
  apiActionTypes.CREATE_EVENT_REQUEST_ERROR,
);

export const locksRequestMade = makeActionCreator(
  apiActionTypes.LOCKS_REQUEST_MADE,
);

export const locksRequestSuccess = makeActionCreator<[ITeamData | ILockData]>(
  apiActionTypes.LOCKS_REQUEST_SUCCESS,
  'payload',
);

export const locksRequestError = makeActionCreator(
  apiActionTypes.LOCKS_REQUEST_ERROR,
);

export const updateLocksRequestMade = makeActionCreator(
  apiActionTypes.UPDATE_LOCKS_REQUEST_MADE,
);

export const updateLocksRequestSuccess = makeActionCreator(
  apiActionTypes.UPDATE_LOCKS_REQUEST_SUCCESS,
  'payload',
);

export const updateLocksRequestError = makeActionCreator(
  apiActionTypes.UPDATE_LOCKS_REQUEST_ERROR,
);

export const saveTeamName = makeActionCreator(
  apiActionTypes.SAVE_TEAM_NAME,
  'teamName',
);

export const saveFundraisingPagesData = makeActionCreator<
  [IFundraisingPagesData]
>(apiActionTypes.SAVE_FUNDRAISING_PAGES, 'data');

export const saveEventDetails = makeActionCreator(
  apiActionTypes.SAVE_EVENT_DETAILS,
  'data',
);

export const saveMembersListData = makeActionCreator<[IMembersListData]>(
  apiActionTypes.SAVE_MEMBERS_LIST_DATA,
  'data',
);

export const saveFrpData = makeActionCreator<[IFrpData]>(
  apiActionTypes.SAVE_FRP_DATA,
  'data',
);

export const saveMembershipPolicy = makeActionCreator<[TMembershipPolicy]>(
  apiActionTypes.SAVE_MEMBERSHIP_POLICY,
  'membershipPolicy',
);

export const saveGDPRConsents = makeActionCreator<[IGDPRConsent[]]>(
  apiActionTypes.SAVE_GDPR_CONSENTS,
  'GDPRConsents',
);

export const getEventRequestMade = makeActionCreator(
  apiActionTypes.GET_EVENT_REQUEST_MADE,
);

export const getEventRequestSuccess = makeActionCreator<[IEventData]>(
  apiActionTypes.GET_EVENT_REQUEST_SUCCESS,
  'data',
);

export const getEventRequestError = makeActionCreator<[string]>(
  apiActionTypes.GET_EVENT_REQUEST_ERROR,
  'errorStatus',
);

export const getAppDataRequestMade = makeActionCreator(
  apiActionTypes.GET_APP_DATA_REQUEST_MADE,
);

export const getAppDataRequestSuccess = makeActionCreator(
  apiActionTypes.GET_APP_DATA_REQUEST_SUCCESS,
);

export const getAppDataRequestError = makeActionCreator<[string]>(
  apiActionTypes.GET_APP_DATA_REQUEST_ERROR,
  'errorStatus',
);

export const fetchFundraisingPagesRequestMade = makeActionCreator(
  apiActionTypes.GET_FUNDRAISING_PAGES_REQUEST_MADE,
);

export const fetchFundraisingPagesRequestSuccess = makeActionCreator<
  [IFundraisingPagesData]
>(apiActionTypes.GET_FUNDRAISING_PAGES_REQUEST_SUCCESS, 'data');

export const fetchFundraisingPagesRequestError = makeActionCreator<[string]>(
  apiActionTypes.GET_FUNDRAISING_PAGES_REQUEST_ERROR,
  'errorStatus',
);

export const getCharityDataRequestMade = makeActionCreator(
  apiActionTypes.GET_CHARITY_DATA_REQUEST_MADE,
);

export const getCharityDataRequestSuccess = makeActionCreator<
  [{ countryCode: string }]
>(apiActionTypes.GET_CHARITY_DATA_REQUEST_SUCCESS, 'data');

export const getCharityDataRequestError = makeActionCreator<[string]>(
  apiActionTypes.GET_CHARITY_DATA_REQUEST_ERROR,
  'errorStatus',
);

export const submitTeamNameRequestMade = makeActionCreator(
  apiActionTypes.SUBMIT_TEAM_NAME_REQUEST_MADE,
);
export const submitTeamNameRequestSuccess = makeActionCreator(
  apiActionTypes.SUBMIT_TEAM_NAME_REQUEST_SUCCESS,
);
export const submitTeamNameRequestError = makeActionCreator<[string]>(
  apiActionTypes.SUBMIT_TEAM_NAME_REQUEST_ERROR,
  'errorStatus',
);

export const updateNumberOfMembers = makeActionCreator<[number]>(
  apiActionTypes.UPDATE_NUMBER_OF_MEMBERS,
  'numberOfMembers',
);

export const submitTeamDataRequestMade = makeActionCreator(
  apiActionTypes.SUBMIT_TEAM_DATA_REQUEST_MADE,
);
export const submitTeamDataRequestSuccess = makeActionCreator<
  [IEditTeamFormProps]
>(apiActionTypes.SUBMIT_TEAM_DATA_REQUEST_SUCCESS, 'data');
export const submitTeamDataRequestError = makeActionCreator<[string]>(
  apiActionTypes.SUBMIT_TEAM_DATA_REQUEST_ERROR,
  'errorStatus',
);

export const setErrorStatus = makeActionCreator(
  apiActionTypes.SET_ERROR_STATUS,
  'errorStatus',
);
